import {BaseApp, BaseAppProps, ContextType} from "./BaseApp";
import {ProvisionedAppConfig, ProvisionedAppContext} from "./types";
import {JSON_OBJECT} from "./json/helpers";

export abstract class ProvisionedApp extends BaseApp implements ProvisionedAppContext {

  static CONTEXT: ProvisionedAppContext;

  constructor(props: BaseAppProps, context: any) {
    super(props, context);
    ProvisionedApp.CONTEXT = this;
  }

  contextType(): ContextType {
    return ContextType.PROVISIONED_APP;
  }

  protected onConfigureApp() {
    super.onConfigureApp();
    const provisionedAppConfig = this.getProvisionedAppConfig();
    if (provisionedAppConfig) {
      this.applyProvisionedAppConfig(provisionedAppConfig);
    }
  }

  abstract getProvisionedAppId(): string;

  abstract getProvisionedAppConfig(): ProvisionedAppConfig;
}
